export default class ProcessRun {
    Id: string = '';
    Name: string = '';
    FullName: string = '';

    constructor(data?: any) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
}